import Link from "next/link";
import Router, { useRouter } from "next/router";
import { classNames } from "primereact/utils";
import { OverlayPanel } from "primereact/overlaypanel";
import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { LayoutContext } from "./context/layoutcontext";
import { signOut } from "next-auth/react";
import { useSession } from "next-auth/react";
import { StyleClass } from "primereact/styleclass";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Badge } from "primereact/badge";
import { ListBox } from "primereact/listbox";
// import postData from "../lib/Axios";
import { Accordion, AccordionTab } from "primereact/accordion";
import GuideTable from "../components/guide/admin/guideManager";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currencyChange } from "../utilities/generaltool";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

const AppTopbar = forwardRef((props, ref) => {
  const router = useRouter();
  const { layoutConfig, layoutState, onMenuToggle, showProfileSidebar } = useContext(LayoutContext);
  const menubuttonRef = useRef(null);
  const topbarmenuRef = useRef(null);
  const topbarmenubuttonRef = useRef(null);
  const op = useRef(null);
  const openBtnRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [guideBtn, setGuideBtn] = useState({ disabled: true, role: "" });
  const [guideDialog, setGuideDialog] = useState({ show: false, data: [], load: false });
  const [appUsed, setAppUsed] = useState({
    show: false,
    data: [],
    load: false,
    searchVal: "",
    countDownVal: "",
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      aplikasi: { value: null, matchMode: FilterMatchMode.CONTAINS },
      countdown: { value: null, matchMode: FilterMatchMode.CONTAINS },
    },
  });
  const [apps, setApps] = useState({
    data: [],
    load: false,
    searchVal: "",
  });
  const [ticketNotif, setTicketNotif] = useState({
    data: 0,
    load: false,
  });
  const [guideManager, setGuideManager] = useState({ show: false, data: [] });

  const { data: session, status } = useSession();

  useImperativeHandle(ref, () => ({
    menubutton: menubuttonRef.current,
    topbarmenu: topbarmenuRef.current,
    topbarmenubutton: topbarmenubuttonRef.current,
  }));

  const handleOutsideClick = (event) => {
    if (openBtnRef.current && !openBtnRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  const onClickLogout = () => {
    const local = window.location.origin;
    signOut({ callbackUrl: `${local}/auth/login` });
  };

  useEffect(() => {
    router.events.on("routeChangeComplete", () => setIsVisible(false));
    // Menambahkan event listener ketika komponen di-mount
    document.addEventListener("mousedown", handleOutsideClick);

    // Membersihkan event listener ketika komponen di-unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    setGuideBtn({ disabled: false, role: session?.user?.userRole });
    getAppUse();
    getApps();
    getTicketNotif();
  }, [session]);

  const handleGuide = async () => {
    setGuideDialog({ show: false, data: [], load: true });

    try {
      const headers = {
        "Content-Type": "application/json",
        "X-ENDPOINT": "/api/guide",
        "X-IDUPDATE": "",
      };

      const response = await fetch("/api/_apibase_crud/", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setGuideDialog({ show: false, data: [], load: false });
        return;
      }

      const data = await response.json();

      if (data.length > 0) {
        setGuideDialog({ show: true, data: data, load: false });
      }
    } catch (error) {
      setGuideDialog({ show: false, data: [], load: false });
      console.error(error);
    }
  };

  const getTicketNotif = async () => {
    setTicketNotif(p => ({ ...p, load: true }));
    try {
      const headers = {
        "Content-Type": "application/json",
        "X-ENDPOINT": '/api/ticket/notification',
      };

      const response = await fetch("/api/_apibase_crud", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setTicketNotif((p) => ({ ...p, load: false }));
        return;
      }

      const res = await response.json();
      setTicketNotif(p => ({ ...p, data: res.data }));
    } catch (error) {
      const err = error.response?.data || error;
      console.log(err)
    } finally {
      setTicketNotif(p => ({ ...p, load: false }));

    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getTicketNotif();
    }, 30000);

    return () => clearInterval(interval);
  }, [session]);

  const getAppUse = async () => {
    setAppUsed((p) => ({ ...p, load: true }));

    try {
      let endpoint = "";

      if (session?.user?.userRole == "client") {
        endpoint = "/api/dashboard/apps_use";
      } else {
        endpoint = "/api/dashboard/users_use_app";
      }
      const headers = {
        "Content-Type": "application/json",
        "X-ENDPOINT": endpoint,
      };

      const response = await fetch("/api/_apibase_crud", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setAppUsed((p) => ({ ...p, load: false }));
        return;
      }

      const data = await response.json();

      if (data?.data.length > 0) {
        let now = new Date();

        //* One day Time in ms (milliseconds)
        //* (1000 * 3600 * 24)

        const res = data?.data
          ?.filter((val) => {
            let expired = new Date(val?.expired);
            let differentInTime = expired?.getTime() - now?.getTime();
            let differentInDays = Math.floor(differentInTime / (1000 * 3600 * 24));

            return differentInDays <= 7;
          })
          .map((val, i) => {
            let expired = new Date(val?.expired);
            let differentInTime = expired?.getTime() - now?.getTime();
            let differentInDays = Math.floor(differentInTime / (1000 * 3600 * 24));

            let remainingTime = differentInTime % (1000 * 3600 * 24);
            let differenceInHours = Math.floor(remainingTime / (1000 * 3600));
            let differenceInMinutes = Math.floor((remainingTime % (1000 * 3600)) / (1000 * 60));

            let pesan = "";

            if (differentInDays >= 0 && differentInDays <= 7) {
              pesan = "Tersisa ";
              if (differentInDays > 0) pesan += `${differentInDays} hari `;
              if (differenceInHours > 0) pesan += `${differenceInHours} jam `;
              if (differenceInMinutes > 0) pesan += `${differenceInMinutes} menit`;
            } else if (differentInDays < 0) {
              pesan = "Sudah kedaluwarsa";
            }

            return {
              ...val,
              countdown: pesan,
              differentInDays: differentInDays,
            };
          })
          .sort((a, b) => {
            return a.differentInDays - b.differentInDays;
          });

        console.log(res);

        setAppUsed({ data: res || [], load: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAppUsed((p) => ({ ...p, load: false }));
    }
  };
  const getApps = async () => {
    setApps((p) => ({ ...p, load: true }));

    try {
      let endpoint = "";

      const headers = {
        "Content-Type": "application/json",
        "X-ENDPOINT": "/api/dashboard/get_count_apps",
      };

      const response = await fetch("/api/_apibase_crud", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setApps((p) => ({ ...p, load: false }));
        return;
      }

      const data = await response.json();

      if (data?.data.length > 0) {
        setApps({ data: data.data || [], load: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setApps((p) => ({ ...p, load: false }));
    }
  };

  const notifHeader = () => {
    return (
      <>
        <div className="flex w-full gap-2">
          <span className="p-input-icon-left w-full">
            <i className="pi pi-search" />
            <InputText
              value={appUsed.searchVal}
              className="w-full"
              onChange={(e) => {
                const value = e.target.value;
                setAppUsed((prev) => ({
                  ...prev,
                  filters: {
                    ...prev.filters, // Pertahankan filter yang ada
                    global: { value: value, matchMode: FilterMatchMode.CONTAINS },
                  },
                  searchVal: value,
                }));
              }}
              placeholder="Search"
            />
          </span>

          <Dropdown
            options={apps.data}
            value={apps.searchVal}
            showClear
            onChange={(e) => {
              const value = e.value;
              setAppUsed((prev) => ({
                ...prev,
                filters: {
                  ...prev.filters, // Pertahankan filter yang ada
                  aplikasi: { value: value, matchMode: FilterMatchMode.CONTAINS },
                },
              }));
              setApps((prev) => ({ ...prev, searchVal: value }));
              setApps((p) => ({ ...p, searchVal: value }));
            }}
            placeholder="Aplikasi"
            optionValue="nama"
            optionLabel="nama"
          />

          <Dropdown
            options={[
              { label: "Tersisa", value: "tersisa" },
              { label: "Kedaluwarsa", value: "kedaluwarsa" },
            ]}
            placeholder="Masa Expired"
            value={appUsed.countDownVal}
            showClear
            onChange={(e) => {
              const value = e.value;
              setAppUsed((prev) => ({
                ...prev,
                filters: {
                  ...prev.filters, // Pertahankan filter yang ada
                  countdown: { value: value, matchMode: FilterMatchMode.CONTAINS },
                },
                countDownVal: value,
              }));
            }}
            optionValue="value"
            optionLabel="label"
          />
        </div>
      </>
    );
  };

  return (
    <div className="layout-topbar">
      {/* <Link href="/" className="layout-topbar-logo">
                <img src={`/layout/images/logo-${layoutConfig.colorScheme !== 'light' ? 'white' : 'dark'}.svg`} width="47.22px" height={'35px'} widt={'true'} alt="logo" />
                <span>Godong</span>
            </Link> */}
      <Link
        href="/"
        className="layout-topbar-logo"
        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img src={`/layout/images/godongpng.png`} width="auto" height={"40px"} />
        {/* <span>Godong SP</span> */}
      </Link>

      <button
        ref={menubuttonRef}
        type="button"
        className="p-link layout-menu-button layout-topbar-button"
        onClick={onMenuToggle}>
        <i className="pi pi-bars" />
      </button>

      <button
        ref={topbarmenubuttonRef}
        type="button"
        className="p-link layout-topbar-menu-button layout-topbar-button"
        onClick={showProfileSidebar}>
        <i className="pi pi-ellipsis-v" />
      </button>

      <div
        ref={topbarmenuRef}
        className={classNames("layout-topbar-menu", {
          "layout-topbar-menu-mobile-active": layoutState.profileSidebarVisible,
        })}>
        <Button
          label="Panduan"
          className="mr-2"
          text
          disabled={guideBtn.disabled}
          loading={guideDialog.load}
          style={{
            backgroundColor: "transparent",
            color: "black",
            border: "none",
            outline: "none",
            boxShadow: "none",
          }}
          onMouseDown={(e) => {
            e.target.style.color = "grey";
          }}
          onMouseUp={(e) => {
            e.target.style.color = "black";
          }}
          icon="pi pi-book"
          onClick={() => {
            if (guideBtn.role !== "client") {
              // console.log(session.user);
              setGuideManager({ show: true, data: [] });
            } else {
              handleGuide();
            }
          }}></Button>

        <div className="flex align-items-center">
          <div className="text-700">{session?.user?.name}</div>
        </div>
        <div ref={openBtnRef}>
          {/* <StyleClass nodeRef={openBtnRef} selector=".popup-box" toggleClassName="hidden"> */}
          <button
            type="button"
            onClick={() => setIsVisible((prev) => !prev)}
            className="p-link layout-topbar-button p-overlay-badge">
            <i className="pi pi-user"></i>
            <span>Profile</span>
          </button>
          {/* </StyleClass> */}
          <div
            className={`p-3 surface-overlay top-auto border-round origin-top absolute animation-duration-500 popup-box ${isVisible ? "" : "hidden"
              }`}
            style={{ right: "5px" }}>
            <ul className="list-none m-0 p-0">
              <li>
                <Link href="/settings" style={{ color: "#495057" }}>
                  <i className="pi pi-cog"></i> settings
                </Link>
              </li>
              <div className="mt-2 mb-2" style={{ width: "100%", lineHeight: "1px", backgroundColor: "#c1c1c1" }}>
                &nbsp;
              </div>
              <li>
                <span className="p-link" onClick={onClickLogout}>
                  <i className="pi pi-sign-out"></i> log out
                </span>
              </li>
            </ul>
          </div>
        </div>

        <Button
          style={{
            backgroundColor: "transparent",
            color: "black",
            border: "none",
            outline: "none",
            boxShadow: "none",
          }}
          text
          onMouseDown={(e) => {
            e.target.style.color = "grey";
          }}
          onMouseUp={(e) => {
            e.target.style.color = "black";
          }}
          disabled={appUsed.load}
          onClick={() => setAppUsed((p) => ({ ...p, show: true }))}>
          <i
            className="pi pi-bell p-overlay-badge "
            style={{
              fontSize: "20px",
            }}>
            {appUsed.data.length > 0 && <Badge severity="danger" value={appUsed.data.length} size="normal" />}
          </i>
        </Button>

        <Button
          style={{
            backgroundColor: "transparent",
            color: "black",
            border: "none",
            outline: "none",
            boxShadow: "none",
          }}
          text
          onMouseDown={(e) => {
            e.target.style.color = "grey";
          }}
          onMouseUp={(e) => {
            e.target.style.color = "black";
          }}
          disabled={ticketNotif.load}
          onClick={() => session?.user?.userRole == 'client' ? router.push('/ticket') : router.push('/admin/ticket')}>
          <i
            className="pi pi-ticket p-overlay-badge "
            style={{
              fontSize: "20px",
            }}>
            {ticketNotif.data > 0 && <Badge severity="danger" value={ticketNotif.data} size="normal" />}
          </i>
        </Button>

        <Dialog header="Notifikasi" visible={appUsed.show} onHide={() => setAppUsed((p) => ({ ...p, show: false }))}>
          <DataTable
            value={appUsed.data}
            paginator
            selectionMode="single"
            onRowSelect={(e) => {
              const app = e.data.apps;

              if (session?.user?.userRole == "client") {
                router.push("/invoice/payment/" + app);
              }
            }}
            rows={10}
            header={notifHeader}
            filters={appUsed.filters}
            globalFilterFields={["aplikasi", "name", "no_hp", "email"]}>
            <Column field="aplikasi" header="App"></Column>
            {session?.user?.userRole == "client" ? (
              <Column
                field="harga"
                header="Harga"
                body={(rowData) => {
                  return <>Rp{currencyChange(rowData?.harga)}</>;
                }}></Column>
            ) : (
              <Column field="name" header="Pengguna"></Column>
            )}
            {session?.user?.userRole !== "client" && <Column field="email" header="email"></Column>}
            {session?.user?.userRole !== "client" && <Column field="no_hp" header="No Telp"></Column>}
            <Column field="expired" header="Berakhir"></Column>
            <Column
              field="countdown"
              header="Countdown"
              body={(rowData) => {
                let color = "black"; // Default warna
                if (rowData?.countdown.includes("Tersisa")) {
                  color = "orange"; // Warna kuning jika hampir habis
                } else if (rowData?.countdown.includes("kedaluwarsa")) {
                  color = "red"; // Warna merah jika expired
                }
                return <span style={{ color }}>{rowData?.countdown}</span>;
              }}></Column>
          </DataTable>
        </Dialog>

        <Dialog
          visible={guideDialog.show}
          style={{ width: "80%" }}
          header={"Pilih Panduan yang anda ingin baca"}
          onHide={() => setGuideDialog({ show: false, data: [], load: false })}>
          <Accordion multiple style={{ marginTop: "10px" }}>
            {guideDialog.data.map((d, ind) => {
              return (
                <AccordionTab key={ind} header={d.category} className="my-2">
                  <ListBox
                    filter
                    // value={}
                    onChange={(e) => {
                      router.push("/guide/detail/" + "?id=" + e.value.code);
                      setGuideDialog({ show: false, data: [], load: false });
                    }}
                    options={d.guide}
                    optionLabel="name"
                    className="w-full"
                  />
                </AccordionTab>
              );
            })}
          </Accordion>
        </Dialog>
        <Dialog
          visible={guideManager.show}
          style={{ width: "80%" }}
          header={"Guide Manager"}
          onHide={() => setGuideManager({ show: false, data: [] })}>
          <GuideTable onClick={true} />
        </Dialog>
      </div>
    </div>
  );
});

export default AppTopbar;
